module.exports = __webpack_public_path__ + "img/prize_a3.02b0c7a0.png";